const Micro = ({ size = 20, color = 'currentColor', ...other }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <g clip-path="url(#clip0_766_783)">
        <path
          d="M16.9711 8.8101C16.9711 8.63513 16.9016 8.46733 16.7779 8.34361C16.6542 8.21989 16.4864 8.15039 16.3114 8.15039C16.1364 8.15039 15.9686 8.21989 15.8449 8.34361C15.7212 8.46733 15.6517 8.63513 15.6517 8.8101C15.6517 10.3649 15.034 11.8561 13.9346 12.9556C12.8351 14.055 11.344 14.6727 9.78911 14.6727C8.23425 14.6727 6.74308 14.055 5.64364 12.9556C4.54419 11.8561 3.92653 10.3649 3.92653 8.8101C3.92653 8.63513 3.85702 8.46733 3.7333 8.34361C3.60958 8.21989 3.44179 8.15039 3.26682 8.15039C3.09186 8.15039 2.92406 8.21989 2.80034 8.34361C2.67662 8.46733 2.60712 8.63513 2.60712 8.8101C2.60932 10.5996 3.27906 12.3238 4.48533 13.6456C5.69159 14.9674 7.3476 15.7915 9.1294 15.9569V17.7161H6.11675C5.94178 17.7161 5.77399 17.7856 5.65027 17.9093C5.52655 18.0331 5.45704 18.2009 5.45704 18.3758C5.45704 18.5508 5.52655 18.7186 5.65027 18.8423C5.77399 18.966 5.94178 19.0355 6.11675 19.0355H13.4615C13.6364 19.0355 13.8042 18.966 13.9279 18.8423C14.0517 18.7186 14.1212 18.5508 14.1212 18.3758C14.1212 18.2009 14.0517 18.0331 13.9279 17.9093C13.8042 17.7856 13.6364 17.7161 13.4615 17.7161H10.4488V15.9569C12.2306 15.7915 13.8866 14.9674 15.0929 13.6456C16.2992 12.3238 16.9689 10.5996 16.9711 8.8101Z"
          fill={color}
        />
        <path
          d="M9.78914 12.8875C10.8701 12.8863 11.9064 12.4564 12.6707 11.6921C13.435 10.9277 13.865 9.89142 13.8661 8.81049V4.19695C13.6462 -1.20823 5.94965 -1.20823 5.71216 4.19695V8.81049C5.71332 9.89142 6.14323 10.9277 6.90756 11.6921C7.67189 12.4564 8.70821 12.8863 9.78914 12.8875ZM7.03157 4.19695C7.15911 0.546586 12.4192 0.546586 12.5467 4.19695V8.81049C12.5467 9.54185 12.2562 10.2432 11.739 10.7604C11.2219 11.2775 10.5205 11.5681 9.78914 11.5681C9.05778 11.5681 8.35639 11.2775 7.83924 10.7604C7.3221 10.2432 7.03157 9.54185 7.03157 8.81049V4.19695Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_766_783">
          <rect
            width="19.7143"
            height="19.7143"
            fill="white"
            transform="translate(0.142883 0.143066)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Micro;
